import { NexusHeaderLogo, NexusHeader, NexusHeaderMenu, NexusMenuItem } from '@nexus/react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import styles from './Header.module.scss';
import ExitIcon from '@nexus/core/dist/assets/icons/action/ic_exit_to_app_24px.svg';
import SettingsIcon from '@nexus/core/dist/assets/icons/action/ic_settings_24px.svg';
import EYIcon from '../../../assets/images/icon-color.png';
import { useAppDispatch, useAppSelector } from '../../../../store';
import PortalDropDown, { IOption } from './PortalDropdown';
// import { endPointUrls } from '../../../../store/constants/endPoints';
import { resetRateFinderData } from '../../../../store/customSlice/rateFinderSlice';
import {
    resetApportionmentData,
    resetFormFields,
    resetFormFieldsForStep3,
    resetStep3Data,
    setErrorMessageContent,
    setWarningMessageVisible,
} from '../../../../store/customSlice/scheduleDetailsSlice';
import {
    removeTokens,
    setUserEntitlements,
    setisScheduleListViewable,
    setisScheduleViewable,
    setUserLogout,
    setisRiskLocatorViewable,
    setisRateFinderViewable,
    setisAdminOrgReadable,
    setisAdminDataEditable,
    setUserEntitlementsDefault,
} from '../../../../store/customSlice/authSlice';
import { useEffect } from 'react';
import PrivacyPolicy from '../../../views/privacy-policy/PrivacyPolicy';
import SessionLogout from '../../../views/session-logout/SessionLogout';
import { logout } from '../../../../store/customSlice/userProfileSlice';
import { setLoggedOut } from '../../../../store/customSlice/homeSlice';
import { ApiState } from '../../../../store/constants/enums';
import { IUserPreferences } from '../../../../store/types/user.type';

// commented for next demo session
const opts = [
    {
        label: 'Settings',
        icon: SettingsIcon,
    },
    {
        label: 'Logout',
        icon: ExitIcon,
    },
    // {
    //     label: 'Administration Portal',
    //     icon: AdminIcon,
    // },
];

const Header = () => {
    const path = useLocation();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { userEntitlements, entitledMenuItems, userLogout, userPopupMessage } = useAppSelector().authSlice;
    const { userPreferences, apiState, logoutRedirectUrl } = useAppSelector().userProfileSlice;
    const { variationApportionmentValidation } = useAppSelector().scheduleDetailsSlice;
    const resetFormData = () => {
        dispatch(resetFormFields());
        dispatch(resetFormFieldsForStep3());
        dispatch(resetStep3Data());
        dispatch(resetRateFinderData());
        dispatch(resetApportionmentData());
    };
    // const menuItems = [
    //     {
    //         title: 'Home',
    //         link: '/',
    //         onClick: resetFormData,
    //     },
    //     {
    //         title: 'Rate Finder',
    //         link: '/rate-finder',
    //         onClick: resetFormData,
    //     },
    //     {
    //         title: 'Risk Locator',
    //         link: '/risk-locator',
    //     },
    //     {
    //         title: 'Tax Schedule',
    //         link: '/schedule-details',
    //     },
    //     {
    //         title: 'Admin',
    //         link: '/admin',
    //     },
    // ];

    type MenuItem = {
        title: string;
        link: string;
        onClick?: () => void;
    };

    interface IEntitlement {
        resourceName: string;
        operation: string;
    }

    // const [entitledMenuItems, setEentitledMenuItems] = useState<MenuItem[]>([]);

    const handleSettings = () => {
        navigate('/settings');
    };

    const handleLogout = () => {
        dispatch(logout()).then(() => {
            dispatch(setLoggedOut(true));
            dispatch(removeTokens());
            localStorage.removeItem('sessionID');
            window.history.replaceState(null, '', '/');
            window.history.pushState(null, '', '/');
        });
    };

    useEffect(() => {
        if (userLogout === true) {
            handleLogout();
            dispatch(setUserLogout(false));
        }
    }, [userLogout]);

    useEffect(() => {
        if (apiState.logout === ApiState.FULFILLED) {
            window.location.replace(logoutRedirectUrl || '/');
        }
    }, [apiState.logout, logoutRedirectUrl]);

    // useEffect(() => {
    //     if (
    //         localStorage.getItem('sessionID') === '' ||
    //         localStorage.getItem('sessionID') === undefined ||
    //         localStorage.getItem('sessionID') === null
    //     ) {
    //         window.location.assign(`${window._env.REACT_APP_BASE_API_URL}${endPointUrls.auth}`);
    //     }
    // }, []);

    useEffect(() => {
        if (userEntitlements?.data?.entitlements?.applications) {
            const applications = userEntitlements.data.entitlements.applications[0]?.resources;
            const newMenuItems: MenuItem[] = [];
            newMenuItems.push({
                title: 'Home',
                link: '/',
                onClick: resetFormData,
            });

            dispatch(setisScheduleListViewable(false));
            if (!applications || applications.length > 0) {
                // const distinctResourceNames = applications.map((resource: IEntitlement) => {
                //     return resource.resourceName;
                // });

                if (
                    applications.some(
                        (resource: IEntitlement) =>
                            resource.resourceName === 'Schedule-list-ui' && resource.operation === 'READ',
                    )
                ) {
                    dispatch(setisScheduleListViewable(true));
                } else {
                    dispatch(setisScheduleListViewable(false));
                }
                if (
                    applications.some(
                        (resource: IEntitlement) =>
                            resource.resourceName === 'Tax-Schedule-ui' && resource.operation === 'READ',
                    )
                ) {
                    dispatch(setisScheduleViewable(true));
                    newMenuItems.push({
                        title: 'Tax Schedule',
                        link: '/schedule-details',
                    });
                } else {
                    dispatch(setisScheduleViewable(false));
                }

                if (
                    applications.some(
                        (resource: IEntitlement) =>
                            resource.resourceName === 'Rate-Finder-ui' && resource.operation === 'READ',
                    )
                ) {
                    dispatch(setisRateFinderViewable(true));
                    newMenuItems.push({
                        title: 'Rate Finder',
                        link: '/rate-finder',
                        onClick: resetFormData,
                    });
                } else {
                    dispatch(setisRateFinderViewable(false));
                }

                if (
                    applications.some(
                        (resource: IEntitlement) =>
                            resource.resourceName === 'Risk-Locator-ui' && resource.operation === 'READ',
                    )
                ) {
                    dispatch(setisRiskLocatorViewable(true));
                    newMenuItems.push({
                        title: 'Risk Locator',
                        link: '/risk-locator',
                    });
                } else {
                    dispatch(setisRiskLocatorViewable(false));
                }
                if (
                    applications.some(
                        (resource: IEntitlement) =>
                            resource.resourceName === 'Admin-Org-Manage-ui' && resource.operation === 'READ',
                    )
                ) {
                    newMenuItems.push({
                        title: 'Admin',
                        link: '/admin',
                    });
                    dispatch(setisAdminOrgReadable(true));
                } else {
                    dispatch(setisAdminOrgReadable(false));
                }
                if (
                    applications.some(
                        (resource: IEntitlement) =>
                            resource.resourceName === 'Admin-Data-Manage-ui' && resource.operation === 'UPDATE',
                    )
                ) {
                    dispatch(setisAdminDataEditable(true));
                } else {
                    dispatch(setisAdminDataEditable(false));
                }
            } else {
                dispatch(setUserEntitlementsDefault());
            }
            dispatch(setUserEntitlements(newMenuItems));
        }
    }, [userEntitlements]);

    const isPrivacyAccepted = (userPreferences: IUserPreferences) => {
        if (
            // userPreferences.isAcceptedPrivacyNotice === undefined ||
            userPreferences.isAcceptedPrivacyNotice === null ||
            userPreferences.isAcceptedPrivacyNotice === false ||
            // userPreferences.isAcceptedTnc === undefined ||
            userPreferences.isAcceptedTnc === null ||
            userPreferences.isAcceptedTnc === false
        ) {
            return false;
        } else {
            return true;
        }
    };

    const handleMenuClick = (e: any) => {
        if (variationApportionmentValidation) {
            e.preventDefault();
            dispatch(setWarningMessageVisible(true));
            dispatch(
                setErrorMessageContent(
                    'Use Save Draft button in the current screen before proceeding to the next screen. Changes will not be retained otherwise.',
                ),
            );
        }
    };

    return (
        <>
            <div tabIndex={-1} className={styles.header} data-testid='page-header' id='page-header'>
                {entitledMenuItems && entitledMenuItems.length > 0 && (
                    <NexusHeader tabIndex={-1} className='nexus-header-color'>
                        <div className={styles['header-content']}>
                            <NexusHeaderLogo tabIndex={-1}>
                                <div className='nexus-flex-row'>
                                    <img
                                        src={EYIcon}
                                        alt='EY Logo'
                                        width='75'
                                        height='75'
                                        style={{ borderRadius: '4px' }}
                                        tabIndex={-1}
                                    />
                                    <div
                                        className={`nexus-subtitle nexus-ml-2 ${styles['app-title-margin']}`}
                                        tabIndex={-1}
                                    >
                                        IPT Analyzer
                                    </div>
                                </div>
                            </NexusHeaderLogo>
                            <NexusHeaderMenu data-testid='nexus-header-menu' className={styles['menu-header']}>
                                {entitledMenuItems.map((menuItem: MenuItem, idx: number) => (
                                    <NexusMenuItem
                                        className={`${menuItem.link}` === path.pathname ? 'menu-item-highlighter' : ''}
                                        key={idx}
                                        data-testid={menuItem.title}
                                    >
                                        <Link to={menuItem.link} onClick={handleMenuClick}>
                                            {menuItem.title}
                                        </Link>
                                    </NexusMenuItem>
                                ))}
                                <NexusMenuItem
                                    className={`/help` === path.pathname ? 'menu-item-highlighter' : ''}
                                    key={10}
                                    data-testid={'help'}
                                >
                                    <Link to={'/help'} onClick={handleMenuClick}>
                                        {'Help'}
                                    </Link>
                                </NexusMenuItem>
                            </NexusHeaderMenu>
                            <NexusHeaderMenu
                                data-testid='nexus-header-menu-user'
                                className={`${styles['user-menu']} nexus-pr-1`}
                            >
                                <NexusMenuItem className={`${styles['user-img']} nexus-mr-1`}>
                                    <PortalDropDown
                                        options={opts}
                                        onSelect={(option: IOption) => {
                                            if (variationApportionmentValidation) {
                                                dispatch(setWarningMessageVisible(true));
                                                dispatch(
                                                    setErrorMessageContent(
                                                        'Use Save Draft button in the current screen before proceeding to the next screen. Changes will not be retained otherwise.',
                                                    ),
                                                );
                                            } else {
                                                if (option.label === 'Logout') {
                                                    handleLogout();
                                                } else if (option.label === 'Settings') {
                                                    handleSettings();
                                                }
                                            }
                                        }}
                                    />
                                </NexusMenuItem>
                            </NexusHeaderMenu>
                        </div>
                    </NexusHeader>
                )}
            </div>
            {userPreferences && !isPrivacyAccepted(userPreferences) && (
                <PrivacyPolicy userPreferences={userPreferences} handleLogout={handleLogout} />
            )}
            {userPopupMessage === true && <SessionLogout handleLogout={handleLogout} />}
        </>
    );
};
export default Header;
